import {
    FaJava,
    FaReact,
    FaHtml5,
    FaCss3Alt,
    FaAws,
    FaGitAlt,
    FaDatabase
} from "react-icons/fa";

import {
    SiLeetcode,
    SiJavascript,
    SiJest,
    SiTailwindcss,
    SiMysql,
    SiSqlite,
    SiHibernate,
    SiJunit5,
    SiThymeleaf,
    SiSpringsecurity,
    SiSpringboot,
    SiIntellijidea,
    SiEclipseide,
    SiVisualstudiocode,
    SiPostman,
    SiAndroidstudio,
    SiGit,
    SiApachekafka,
    SiRedis,
    SiSocketdotio,
    SiWebrtc,
    SiDocker,
    SiElasticsearch,
    SiApacheairflow,
    SiNodedotjs,
    SiPostgresql
} from "react-icons/si";

import { MdArchitecture } from "react-icons/md";

export const username = `guddu1cse`;
export const name = "Guddu Kumar";
export const PAGE_TITLE = `✨ ${name} | Backend Engineer & AI Enthusiast`;
export const organization = `Vymo`;
export const role = `Member of Technical Staff at ${organization}`;
export const profileLink = `https://leetcode.com/LC-${username}/`;
// Base URL for the ass_server backend
const BACKEND_URL = process.env.REACT_APP_API_URL;
export const leetcodeApi = `${BACKEND_URL}/api/leetcode/LC-${username}`;
export const gitHubApi = `https://api.github.com/users/${username}/repos`;
export const linkedin = `https://www.linkedin.com/in/${username}`;
export const github = `https://github.com/${username}`;
export const profileImage = "https://avatars.githubusercontent.com/u/73424882?s=400&u=56dc45a1f9f667ae77bce3faac22a7ee73d68a94&v=4";
export const resume = "https://hackerrank-resume.s3.us-east-1.amazonaws.com/uploads/9758288/OTc1ODI4OA==.pdf";
export const leetcodeProfile = `https://www.leetcode.com/LC-${username}`;
export const instagram = `https://instagram.com/${username}`;
export const email = "guddu.javadev@gmail.com";
export const contact = "8084166187";


export const aboutMe = `Hello, I’m ${name}, a Backend Engineer with 2+ years of experience
in building scalable and high-performance backend systems. I specialize in high-concurrency 
microservices, real-time distributed platforms, and database optimization. 
With a strong foundation in Data Structures and Algorithms (solved 900+ LeetCode problems), 
I have engineered robust solutions utilizing Java 17, Spring Boot, WebSockets, WebRTC, and Kafka. 
I am passionate about building fault-tolerant architectures and Agentic AI applications that 
operate seamlessly at scale.`;

export const footerAbout = `Backend Engineer skilled in Java, Spring Boot, Microservices,
Kafka, WebRTC, WebSockets, and Agentic AI. Passionate about building highly scalable, 
real-time distributed systems and robust backend architectures.`;


export const skills = [
    { name: "Java", icon: <FaJava /> },
    { name: "Spring Boot", icon: <SiSpringboot /> },
    { name: "JavaScript / TS", icon: <SiJavascript /> },
    { name: "Node.js", icon: <SiNodedotjs /> },
    { name: "React.js", icon: <FaReact /> },
    { name: "Microservices", icon: <MdArchitecture /> },
    { name: "Kafka", icon: <SiApachekafka /> },
    { name: "Redis", icon: <SiRedis /> },
    { name: "WebSockets", icon: <SiSocketdotio /> },
    { name: "WebRTC", icon: <SiWebrtc /> },
    { name: "PostgreSQL", icon: <SiPostgresql /> },
    { name: "MySQL / SQL", icon: <SiMysql /> },
    { name: "Elasticsearch", icon: <SiElasticsearch /> },
    { name: "AWS", icon: <FaAws /> },
    { name: "Docker", icon: <SiDocker /> },
    { name: "Airflow", icon: <SiApacheairflow /> },
    { name: "Spring AI", icon: <SiSpringboot /> },
    { name: "DSA", icon: <SiLeetcode /> },
];

//list of tools
export const toolsList = [
    { name: "SQL Workbench", icon: <FaDatabase /> },
    { name: "IntelliJ IDEA", icon: <SiIntellijidea /> },
    { name: "Eclipse", icon: <SiEclipseide /> },
    { name: "Spring Boot Tool Suite", icon: <SiSpringboot /> },
    { name: "VS Code", icon: <SiVisualstudiocode /> },
    { name: "Postman", icon: <SiPostman /> },
    { name: "Android Studio", icon: <SiAndroidstudio /> },
    { name: "Git", icon: <SiGit /> },
];

//list of certifications
export const certifications = [
    {
        title: "Spring Boot",
        url: "https://s3-ap-southeast-1.amazonaws.com/learnyst/schools/137927/certificates/137999/7662983_137999.pdf?1680688572",
        icon: <SiSpringboot style={{ color: '#6DB33F' }} />, // Spring icon
    },
    {
        title: "Data Structures and Algorithms",
        url: "https://assets.nextleap.app/certificate/Cohort-5-9faa98583d17fdf3d8c761fba59ddd14.pdf",
        icon: <SiLeetcode className="text-yellow-600" />, // LeetCode icon
    },
    {
        title: "System Design",
        url: "https://d3r0n59fu7ub44.cloudfront.net/certificates/courseCertificate/2024-02-02/course_64e39613c899c20312714e9e_user_64f82ae8af97410c0679de08.pdf",
        icon: <MdArchitecture className="text-purple-600" />, // System Design icon
    },
    {
        title: "React.js",
        url: "https://www.mygreatlearning.com/certificate/PLWQVOVE",
        icon: <FaReact style={{ color: '#6ccff6' }} />, // Frontend Mentor icon
    },
    {
        title: "Frontend Developer Program",
        url: "https://www.edyoda.com/public-certificate/guddu1cse/1482",
        icon: <FaReact style={{ color: '#6ccff6' }} />, // Frontend Mentor icon
    },
];

//list of experiences
export const experiences = [
    {
        year: 2026,
        company: "Tuckit",
        duration: "Jan 2026 - Present",
        role: "Member of Technical Staff (Backend)",
        link: "#",
        description: `• Architected Spring Boot booking engine handling 1000+ concurrent requests with <300ms API latency.
• Developed a Node.js WebRTC remote agent enabling browser-based remote desktop control and live streaming for IoT kiosks.
• Built an xterm.js-powered remote terminal console using WebSockets (STOMP) for shell command execution and live metrics.
• Engineered an offline-first edge fault-tolerance module caching encrypted states on kiosk hardware.
• Integrated Razorpay API with idempotent transaction processing and optimized SXSSFWorkbook report streaming (90% latency reduction).`,
        tech: ["Spring Boot", "WebRTC", "Node.js", "WebSockets", "Razorpay"]
    },
    {
        year: 2025,
        company: "Vymo Asia",
        duration: "Jan 2025 - Dec 2025",
        role: "Member of Technical Staff (Backend)",
        link: "https://www.vymo.com/",
        description: `• Developed Java/Spring Boot microservices for enterprise lead management and hierarchy-based access control.
• Designed SSO-based authentication improving secure two-way authentication flows.
• Enhanced notification pipelines using Kafka, achieving a 99.9% delivery success rate.
• Maintained data engineering pipelines using Kafka, Redis, Airflow, and Elasticsearch.`,
        tech: ["Microservices", "Kafka", "Redis", "Elasticsearch", "Airflow"]
    },
    {
        year: 2024,
        company: "Ekloud Inc.",
        duration: "Jul 2024 - Dec 2024",
        role: "Software Engineering Intern",
        link: "https://ekloudservices.com/",
        description: `• Reduced JVM memory usage and API latency by migrating complex application-layer filtering logic directly into database SQL queries.`,
        tech: ["Java", "SQL", "JVM Optimization"]
    },
];

// Featured Projects
export const featuredProjects = [
    {
        name: "SelfServe.ai Agent",
        description: "Engineered an AI conversational assistant using Spring AI and Redis caching to serve streaming responses over WebSocket connections.",
        link: "https://github.com/guddu1cse/SelfServe-ai",
        tech: ["Spring Boot", "Spring AI", "Node.js", "React.js", "Redis", "MongoDB", "WebSockets"]
    },
    {
        name: "CollabDocs",
        description: "Real-Time Collaborative Document Platform built like Google Docs. Uses Yjs CRDTs and WebSockets for conflict-free real-time collaboration, with Kafka-backed persistence and Elasticsearch-powered search.",
        link: "https://github.com/guddu1cse/CollabDocs",
        tech: ["Java", "Spring Boot", "Yjs", "CRDTs", "WebSockets", "Kafka", "PostgreSQL", "Elasticsearch"]
    }
];